export default {
  reg: {
    letter: 'Seules les lettres anglaises et les espaces sont autorisés',
  },
}
